export const templates = [
    "standard",
    "purple-gradient",
    "green-gradient",
    "orange-gradient",
    "blue-gradient",
];
